import * as React from "react";
const DeployIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M4.5 16.5C3.12 18.13 2.75 21.25 2.75 21.25C2.75 21.25 5.87 20.88 7.5 19.5C8.42 18.71 8.43 17.34 7.54 16.46C7.1 16.03 6.52 15.81 5.94 15.83C5.36 15.84 4.81 16.08 4.5 16.5Z"
      stroke="#414651"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 4L16.5 2L22 7.5L20 9.5"
      stroke="#414651"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6L19 2"
      stroke="#414651"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 14.5L5 19"
      stroke="#414651"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 4L11.23 7.27C10.16 6.1 8.68 5.43 7.1 5.43L4.26 8.27C6.34 8.59 8.3 9.57 9.73 11.01L12.99 14.27C14.43 15.7 15.41 17.66 15.73 19.74L18.57 16.9C18.57 15.32 17.9 13.84 16.73 12.77L20 9.5"
      stroke="#414651"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default DeployIcon;
